module.exports = __webpack_public_path__ + "img/truck-delivered.65bd2de8.svg";